import React from 'react';
import '../css/style.css';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-bottom">
          <p>&copy; 2025 Anusha Ravichandran. All rights reserved.</p>
          <div className="social-links">
            <a href="https://github.com/Anusha-RG" target="_blank" rel="noopener noreferrer"><i className="fab fa-github"></i></a>
            <a href="https://www.linkedin.com/in/anusha-ravichandran-g/" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin"></i></a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;